import moment from 'moment';
import 'moment/locale/ca';
import __isEmpty from 'lodash/isEmpty';

const getTimeFromNow = (data) => {
    const d = moment(data, 'DD/MM/YYYY HH:mm:ss');
    const now = moment();

    const diffInMinutes = now.diff(d, 'minutes');
    const diffInHours = now.diff(d, 'hours');
    const diffInDays = now.diff(d, 'days');

    if (diffInMinutes < 60) {
        if (diffInMinutes === 0) {
            return 'Fa pocs segons';
        } else {
            return `Fa ${diffInMinutes} ${diffInMinutes === 1 ? 'minut' : 'minuts'}`;
        }
    } else if (diffInHours < 24) {
        return `Fa ${diffInHours} ${diffInHours === 1 ? 'hora' : 'hores'}`;
    } else {
        return `Fa ${diffInDays} ${diffInDays === 1 ? 'dia' : 'dies'}`;
    }
};

const getTimeNoti = (data, showDiffHours = true) => {
    const mesosAbreviats = ['gen.', 'febr.', 'març', 'abr.', 'maig', 'juny', 'jul.', 'ag.', 'set.', 'oct.', 'nov.', 'des.'];
    const now = moment();
    const dateUpdate = moment(data, 'DD/MM/YYYY hh:mm:ss');
    const diffHours = now.diff(dateUpdate, 'hours');
    if (diffHours < 24 && showDiffHours) {
        if (diffHours >= 1) {
            return `fa ${diffHours} h`;
        } else {
            const diffMinutes = now.diff(dateUpdate, 'minutes');
            if (diffMinutes === 0) {
                return 'fa pocs segons';
            } else {
                return `fa ${diffMinutes} min`;
            }
        }
    } else {
        const dia = dateUpdate.date();
        const mes = mesosAbreviats[dateUpdate.month()];
        const any = dateUpdate.year();
        const horesMinuts = dateUpdate.format('HH.mm');
        return `${dia} ${mes} ${any}, ${horesMinuts}`;
    }
};

const getHora = (data) => {
    const d = moment(data, 'DD/MM/YYYY hh:mm:ss'); //14/04/2024 23:54:04
    return d.locale('ca').format('HH.mm');
};

const getHoraAmbPunt = (hora) => {
    return hora.replace(':', '.');
};

const getMinuts = (duration) => {
    const d = moment.duration(duration); //00:24:00
    return d.locale('ca').asMinutes();
};

const getTimeFromFormat = (duration) => {
    const timeSplit = duration?.split(':');
    const horaH = timeSplit[0] != '00' ? parseInt(timeSplit[0]) + ' h' : '';
    const min = timeSplit[1] != '00' ? ' ' + parseInt(timeSplit[1]) + ' min' : '';
    const seg = __isEmpty(min) && __isEmpty(horaH) ? parseInt(timeSplit[2]) + ' seg' : '';
    return (horaH + min + seg).trim();
};

const getdataFormatada = (date) => {
    if (__isEmpty(date)) return null;
    const dateSplit = date.split(' ');
    const timeSplit = dateSplit[1]?.split(':');
    const dateFormatted = dateSplit[0] + ' - ' + timeSplit[0] + '.' + timeSplit[1];
    return dateFormatted;
};

const getDia = (date) => {
    if (__isEmpty(date)) return null;
    const dateSplit = date.split(' ');
    const dateFormatted = dateSplit[0];
    return dateFormatted;
};

const getdataFormatadaBy = (date, separator = '-') => {
    if (__isEmpty(date)) return null;
    return date.split(' ')[0].replaceAll('/', separator);
};

const getNaturalDate = (date) => {
    const mes = parseInt(moment(date, 'DD/MM/YYYY hh:mm:ss').format('MM'));
    const article = mes === 4 || mes === 8 || mes === 10 ? "d'" : 'de ';
    return moment(date, 'DD/MM/YYYY hh:mm:ss')
        .locale('ca')
        .format('DD [' + article + ']MMMM YYYY');
};

const getDateLimit = (days) => {
    return moment().utc().subtract(days, 'days').format('DD/MM/YYYY hh:mm:ss');
};

const showDateUpdate = (dateUpdate, dateLimit) => {
    return moment(dateUpdate, 'DD/MM/YYYY hh:mm:ss') >= moment(dateLimit, 'DD/MM/YYYY hh:mm:ss');
};

const isFormatDateValid = (date, format = 'HH:mm:ss') => {
    return moment(date, format, true).isValid();
};

export {
    getHora,
    getHoraAmbPunt,
    getMinuts,
    getTimeFromFormat,
    getTimeFromNow,
    getdataFormatada,
    getDia,
    getNaturalDate,
    getTimeNoti,
    getDateLimit,
    showDateUpdate,
    getdataFormatadaBy,
    isFormatDateValid
};
